const providersSettingsLinks: any[] = [];
export default providersSettingsLinks;
